import React from 'react';
import classNames from 'classnames';

import { Tooltip } from '../../components';
import { MdVerified } from 'react-icons/md';
import { IoShieldCheckmark } from 'react-icons/io5';

import css from './VerifiedUserMark.module.css';

// Whether the user gets a badge (verified, or part of Freedomly). Callers that
// make verification claims elsewhere use this so they match the badge.
export const hasVerifiedMark = user => {
  const metadata = user?.attributes?.profile?.metadata || {};
  return !!(metadata.verified || metadata.partOfFreedomly);
};

const VerifiedUserMark = props => {
  const { className, rootClassName, user, heroSection } = props;
  const classes = classNames(rootClassName || css.root, className);

  const partOfFreedomly = user?.attributes?.profile?.metadata?.partOfFreedomly;

  if (!hasVerifiedMark(user) && !heroSection) {
    return null;
  }

  // partOfFreedomly takes priority over verified badge
  if (partOfFreedomly) {
    return (
      <Tooltip
        messageId="Tooltip.partOfFreedomly"
        rootClassName={classNames(classes, css.partOfFreedomlyLogo)}
      >
        <IoShieldCheckmark className={css.icon} />
      </Tooltip>
    );
  }
  return (
    <Tooltip
      messageId="Tooltip.verifiedMark"
      rootClassName={classNames(classes, css.verifiedBadge)}
    >
      <MdVerified className={css.icon} />
    </Tooltip>
  );
};

export default VerifiedUserMark;
